var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareTelegram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-181 -797)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 88)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    transform: "translate(181 709)",
    fill: "#20b6f9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.341,8.96l3.792,1.407a2.608,2.608,0,0,0,2.354-.275L14.569,4.7a.462.462,0,0,1,.57.724l-5.98,5.535a.747.747,0,0,0,.056,1.143L15.531,16.9a1.887,1.887,0,0,0,3.006-1.214l2.2-14.195A1.292,1.292,0,0,0,18.954.1L.319,7.988a.523.523,0,0,0,.022.973",
    transform: "translate(190 808)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTelegram);
export default __webpack_public_path__ + "static/media/shareTelegram.2171a00683599a9ea8dbfb47e7a25bb1.svg";
export { ForwardRef as ReactComponent };